var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricehunter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.5H30C31.4142 7.5 32.1213 7.5 32.5606 7.93935C33 8.3787 33 9.0858 33 10.5V25.5C33 26.9142 33 27.6213 32.5606 28.0606C32.1213 28.5 31.4142 28.5 30 28.5H22.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5H6C4.58579 7.5 3.87868 7.5 3.43934 7.93935C3 8.3787 3 9.0858 3 10.5V25.5C3 26.9142 3 27.6213 3.43934 28.0606C3.87868 28.5 4.58579 28.5 6 28.5H13.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.5V31.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricehunter1);
export default __webpack_public_path__ + "static/media/pricehunter1.67e1b6e44ef793ac1299225d088a04ed.svg";
export { ForwardRef as ReactComponent };